import { useEffect, useState } from "react";
import { connect } from "react-redux";

import * as actions from "../../store/actions/index";
import { withRouter } from "../../shared/utility";
import { useMonthCalendar } from "../../hooks/useMonthCalendar";
import MonthCalendar from "../../components/calendar/MonthCalendar";
import ProductionCalendarEventPanel from "../../components/calendar/ProductionCalendarEventPanel";
import EmptyModal from "../../components/modals/EmptyModal";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";
import SlideOver from "../../components/slideOver/SlideOver";

function ProductionCalendar(props) {
  const { logout } = props;
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [slideOver, setSlideOver] = useState({
    open: false,
    childComponent: null,
  });

  const showErrorModal = (message) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          title="Error"
          subtitle={message}
        />
      ),
      open: true,
    });
  };

  const {
    calendar,
    currentMonth,
    loading,
    getCalendar,
    handleDaySelect,
    onChangeMonth,
  } = useMonthCalendar("calendar/production/month", logout, showErrorModal);

  useEffect(() => {
    getCalendar();
  }, []);

  const onDayClick = (day) => {
    handleDaySelect(day.date);
  };

  const onEventClick = (event) => {
    setSlideOver({
      open: true,
      childComponent: (
        <ProductionCalendarEventPanel event={event} setOpen={setSlideOver} />
      ),
    });
  };

  return (
    <>
      <MonthCalendar
        calendar={calendar}
        currentMonth={currentMonth}
        onChangeMonth={onChangeMonth}
        onDayClick={onDayClick}
        onEventClick={onEventClick}
        loading={loading}
        createHref="/manufacture-product"
        createLabel="New Production"
        emptyMessage="No production runs on this day."
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        customClass="max-w-lg"
        setSlideOver={setSlideOver}
      />
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </>
  );
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(actions.logout()),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductionCalendar),
);
